// Translations
import {
  CONDITION_01,
  CONDITION_02,
  CONDITION_03,
  CONDITION_04,
} from '../translations/upload-id-landing.translations';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';

const UPLOAD_ID_LANDING_CONDITION_ASSET_PROPS = {
    customIconStyles: {
      color: COBRANDED_LIGHT_REGULAR_BASE_STYLES.color_comp_lineseparator_main_bg,
    },
    height: '32px',
    width: '32px',
  },
  UPLOAD_ID_LANDING_CONDITIONS = [
    {
      assetId: 'icon_card_id-card',
      text: CONDITION_01,
      testId: 'upload-id-landing-condition-01-',
    },
    {
      assetId: 'icon_objects_flashlight-on',
      text: CONDITION_02,
      testId: 'upload-id-landing-condition-02-',
    },
    {
      assetId: 'icon_symbols_camera',
      text: CONDITION_03,
      testId: 'upload-id-landing-condition-03-',
    },
    {
      assetId: 'icon_devices_mobile',
      text: CONDITION_04,
      testId: 'upload-id-landing-condition-04-',
    },
  ];

export { UPLOAD_ID_LANDING_CONDITIONS, UPLOAD_ID_LANDING_CONDITION_ASSET_PROPS };
